var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfrared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "Infrared",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    d: "M11.25 18.75h1.5V20h-1.5zM11.25 4h1.5v8.5h-1.5zM6.73 16.39A7.96 7.96 0 0 1 4.5 10.5c0-2.26.94-4.3 2.45-5.76l.88.9a6.69 6.69 0 0 0-2.08 4.86c0 1.95.83 3.72 2.15 4.95zm10.3 0-.88-.94a6.69 6.69 0 0 0 2.1-4.95c0-1.91-.8-3.64-2.07-4.86l.88-.9a7.96 7.96 0 0 1 2.44 5.76 7.96 7.96 0 0 1-2.24 5.89zM9.4 13.6a4.24 4.24 0 0 1-1.15-3.1c0-1.19.5-2.28 1.3-3.04l.9.9a2.98 2.98 0 0 0-.95 2.14c0 .8.32 1.53.85 2.07zm5.17 0-.95-.99a2.98 2.98 0 0 0 .88-2.11c0-.84-.36-1.6-.93-2.15l.9-.9a4.24 4.24 0 0 1 1.29 3.05 4.24 4.24 0 0 1-1.19 3.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrared);
export default __webpack_public_path__ + "static/media/infrared.6aa6ebdec5755b7aaf4f3cf80376b577.svg";
export { ForwardRef as ReactComponent };